import qs from "qs";
import { PAGE_SIZE } from "../../../blocks/blog-home-list/getListParams";
import { isBrowser } from "../../../utils";

export function getQuery(req) {
  if (req) {
    return req.query;
  }

  if (isBrowser) {
    return qs.parse(window.location.search.slice(1));
  }
  return {};
}

export function getTagListParams(tags, req) {
  const { page = 1 } = getQuery(req);

  const q = {
    tags,
    _limit: PAGE_SIZE,
    _start: Math.max(page - 1, 0) * PAGE_SIZE,
    _sort: "publishedAt:DESC,published_at:DESC",
  };

  return q;
}
